import RowsBoard from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/RowsBoard/RowsBoard';
import {
    NoPermissionMessage,
    NoPermissionMessagePortfolioPage,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { ActivitiesPredecessors } from 'components/widgets/ActivityCompletionPlan/activitiesPredecessors';
import VersionCompareTrackedActivities from 'components/widgets/ChangeAnalysisTrackedActivities/versionCompareTrackedActivities';
import WidgetCardsComponent from 'components/widgets/ChangeSummary/widgetCardsComponent';
import RenderCriticalAnalysisDelayDrivers from 'components/widgets/CriticalActivitiesAndDelayDrivers/RenderCriticalAnalysisDelayDrivers';
import CriticalPathAdded from 'components/widgets/CriticalPathAdded/criticalPathAdded';
import CriticalPathRemoved from 'components/widgets/CriticalPathRemoved/criticalPathRemoved';
import RenderTopOverdueOverrunActivities from 'components/widgets/DelayedActivities/DelayedActivities';
import RenderFuturePotentialDelayDrivers from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers';
import { FinishDateOverallSummary } from 'components/widgets/FinishDateOverallSummary/FinishDateOverallSummary';
import { FinishDatePredictionCompletionPlan as finishDatePredictionActivitiesPredecesssors } from 'components/widgets/FinishDatePredictionCompletionPlan/FinishDatePredictionCompletionPlan';
import { GanttChart } from 'components/widgets/Gantt/GanttChart';
import HighLevelProgram from 'components/widgets/HighLevelProgram/HighLevelProgram';
import { KeyAchievementsTableComponent } from 'components/widgets/KeyAchievements/keyAchievementsTableComponent';
import KeyActivitiesWidget from 'components/widgets/KeyActivities/KeyActivities';
import LongestAddedActivities from 'components/widgets/LargestAddedActivities/largestAddedActivities';
import LargestDeletedActivities from 'components/widgets/LargestDeletedActivities/largestDeletedActivities';
import LargestDurationVariance from 'components/widgets/LargestDurationVariance/largestDurationVariance';
import LargestFloatChanges from 'components/widgets/LargestFloatChanges/largestFloatChanges';
import MilestonesDistribution from 'components/widgets/MilestonesDistribution/MilestonesDistribution';
import OverallStatus from 'components/widgets/OverallStatus/OverallStatus';
import PrioritiesMatrixComponent from 'components/widgets/PrioritiesMatrix/prioritiesMatrixComponent';
import ProgressSummary from 'components/widgets/ProgressSummary/ProgressSummary';
import ProjectScorecards from 'components/widgets/ProjectScorecards/ProjectScorecards';
import ScoreCardsComponent from 'components/widgets/ProjectSummary/scoreCardsComponent';
import { RecommendationsTable } from 'components/widgets/Recommendations/recommendationsTable';
import RelationshipCountChanges from 'components/widgets/RelationshipCountChanges/relationshipCountChanges';
import RiskDensity from 'components/widgets/RiskDensity/RiskDensity';
import { RiskRegister } from 'components/widgets/RiskRegister/RiskRegister';
import { ProductivityTable } from 'components/widgets/RunRateActivitiesDrilldown/productivityTable';
import { ProductivityRate } from 'components/widgets/RunRateChart/productivityRate';
import RenderCriticalAnalysisIntensity from 'components/widgets/SCurve/Scurve';
import { ChangedActivitiesTable } from 'components/widgets/ScheduleSimulation/components/ChangedActivitiesTable/ChangedActivitiesTable';
import { SharedResourcesAvailability } from 'components/widgets/SharedResourcesAvailability/sharedResourcesAvailability';
import { SingleStory } from 'components/widgets/SingleStory/singleStory';
import SummaryTrackedActivitiesComponent from 'components/widgets/SummaryTrackedActivities/summaryTrackedActivitiesComponent';
import RenderTopDurationOverrunRisk from 'components/widgets/TopDurationOverrunRisk/topDurationOverrunRisk';
import FinishDateChanges from 'components/widgets/TopFinishDateChanges/finishDateChanges';
import RelationshipTypeChanges from 'components/widgets/TopRelationshipTypeChanges/relationshipTypeChanges';
import StartDateChanges from 'components/widgets/TopStartDateChanges/startDateChanges';
import StatusChanges from 'components/widgets/TopStatusChanges/statusChanges';
import { Trends } from 'components/widgets/Trends/Trends';
import { PhasePerformanceBreakdown } from 'components/widgets/phasePerformanceBreakdown/phasePerformanceBreakdown';
import { PhasePerformanceChart } from 'components/widgets/phasePerformanceChart/phasePerformanceChart';
import { ResourcesAnalysisChart } from 'components/widgets/resourcesAnalysisChart/resourcesAnalysisChart';
import { ResourcesAnalysisTable } from 'components/widgets/resourcesAnalysisTable/resourcesAnalysisTable';
import { TimelineAndDensity } from 'components/widgets/timelineAndDensity/timelineAndDensity';

export const componentMap = (): IHashmap => ({
    riskHeatMap: {
        Component: RiskDensity,
        NoPermissionMessage,
    },
    criticalityWeightedSCurve: {
        Component: RenderCriticalAnalysisIntensity,
        NoPermissionMessage,
    },

    topCriticalActivitiesDelayDrivers: {
        Component: RenderCriticalAnalysisDelayDrivers,
        NoPermissionMessage,
    },
    topDurationOverrunRisk: {
        Component: RenderTopDurationOverrunRisk,
        NoPermissionMessage,
    },
    progressSummary: {
        Component: ProgressSummary,
        NoPermissionMessage,
    },
    topOverdueOverrunActivities: {
        Component: RenderTopOverdueOverrunActivities,
        NoPermissionMessage,
    },
    highLevelProgramLatest: {
        Component: HighLevelProgram,
        NoPermissionMessage,
    },
    milestonesWeightedSCurve: {
        Component: MilestonesDistribution,
        NoPermissionMessage,
    },
    mySummaryTrackedActivities: {
        Component: SummaryTrackedActivitiesComponent,
        NoPermissionMessage,
    },
    myVersionCompareTrackedActivities: {
        Component: VersionCompareTrackedActivities,
        NoPermissionMessage,
    },
    topStatusChanges: {
        Component: StatusChanges,
        NoPermissionMessage,
    },
    topStartDateChanges: {
        Component: StartDateChanges,
        NoPermissionMessage,
    },
    topFinishDateChanges: {
        Component: FinishDateChanges,
        NoPermissionMessage,
    },
    largestDurationVariance: {
        Component: LargestDurationVariance,
        NoPermissionMessage,
    },
    largestFloatChanges: {
        Component: LargestFloatChanges,
        NoPermissionMessage,
    },
    topRelationshipsTypeChanges: {
        Component: RelationshipTypeChanges,
        NoPermissionMessage,
    },
    topRelationshipsCountChanges: {
        Component: RelationshipCountChanges,
        NoPermissionMessage,
    },
    largestAddedActivities: {
        Component: LongestAddedActivities,
        NoPermissionMessage,
    },
    largestDeletedActivities: {
        Component: LargestDeletedActivities,
        NoPermissionMessage,
    },
    criticalPathAdded: {
        Component: CriticalPathAdded,
        NoPermissionMessage,
    },
    criticalPathRemoved: {
        Component: CriticalPathRemoved,
        NoPermissionMessage,
    },
    topRecommendations: {
        Component: RecommendationsTable,
        NoPermissionMessage,
    },
    versionSummary: {
        Component: WidgetCardsComponent,
        NoPermissionMessage,
    },
    projectSummary: {
        Component: ScoreCardsComponent,
        NoPermissionMessage,
    },
    prioritiesMatrix: {
        Component: PrioritiesMatrixComponent,
        NoPermissionMessage,
    },
    keyAchievements: {
        Component: KeyAchievementsTableComponent,
        NoPermissionMessage,
    },
    projectScorecards: {
        Component: ProjectScorecards,
        NoPermissionMessage: NoPermissionMessagePortfolioPage,
        titleWithoutProjectAndContract: 'Portfolio',
        permission: 'PortfolioPage',
    },
    overallStatus: {
        Component: OverallStatus,
        NoPermissionMessage: NoPermissionMessagePortfolioPage,
        titleWithoutProjectAndContract: 'Portfolio',
        permission: 'PortfolioPage',
    },
    dataStories: {
        Component: SingleStory,
        permission: 'DataStoryRead',
        NoPermissionMessage,
        titleWithoutProjectAndContract: 'Data Story',
    },

    battlecardsRowsBoard: {
        Component: RowsBoard,
        NoPermissionMessage,
    },

    phasePerformanceChart: {
        Component: PhasePerformanceChart,
        titleWithoutProjectAndContract: 'Phase Performance',
        NoPermissionMessage,
        permission: 'PortfolioPage',
    },
    phasePerformanceBreakdown: {
        Component: PhasePerformanceBreakdown,
        titleWithoutProjectAndContract: 'Phase Performance Breakdown',
        NoPermissionMessage,
        permission: 'PortfolioPage',
    },
    activityPredecessors: {
        Component: ActivitiesPredecessors,
        NoPermissionMessage,
    },
    ganttChart: {
        Component: GanttChart,
        NoPermissionMessage,
    },

    sharedResourcesAvailability: {
        Component: SharedResourcesAvailability,
        NoPermissionMessage,
    },
    keyActivities: {
        Component: KeyActivitiesWidget,
        NoPermissionMessage,
    },
    timelineAndDensity: {
        Component: TimelineAndDensity,
        NoPermissionMessage: NoPermissionMessagePortfolioPage,
        titleWithoutProjectAndContract: 'Portfolio',
        permission: 'PortfolioPage',
    },
    finishDateOverallSummary: {
        Component: FinishDateOverallSummary,
        NoPermissionMessage,
    },
    finishDateActivitiesPredecessors: {
        Component: finishDatePredictionActivitiesPredecesssors,
        NoPermissionMessage,
    },
    finishDateFuturePotentialDelayDrivers: {
        Component: RenderFuturePotentialDelayDrivers,
        NoPermissionMessage,
    },
    changedActivities: {
        Component: ChangedActivitiesTable,
        NoPermissionMessage,
    },
    resourcesAnalysisTable: {
        Component: ResourcesAnalysisTable,
        NoPermissionMessage,
    },
    productivityTable: {
        Component: ProductivityTable,
        NoPermissionMessage,
    },
    productivityRate: {
        Component: ProductivityRate,
        NoPermissionMessage,
    },
    resourcesAnalysisChart: {
        Component: ResourcesAnalysisChart,
        NoPermissionMessage,
    },
    trends: {
        Component: Trends,
        NoPermissionMessage,
    },
    riskRegister: {
        Component: RiskRegister,
        NoPermissionMessage,
    },
});
